import { isEqual } from 'lodash';
import React from 'react';
import { AppointmentComponentInterface, ComponentStylingInterface } from '../../../../../interfaces/pagebuilder';

const AppointmentStyling = ({}: ComponentStylingInterface<AppointmentComponentInterface>) => {
  return <div className="wrapper" />;
};
export default React.memo(AppointmentStyling, (prevprop, newprop) => isEqual(prevprop, newprop));
